@switch (element.modelType) {
  @case (SubmodelElementTypes.Property) {
    <app-property [element]="element" [control]="control" />
  }

  @case (SubmodelElementTypes.File) {
    <app-file [element]="element" [control]="control" />
  }

  @case (SubmodelElementTypes.MultiLanguageProperty) {
    <app-multi-language-property
      [element]="element"
      [formGroup]="$any(control)"
    />
  }

  @case (SubmodelElementTypes.SubmodelElementCollection) {
    <div class="d-flex flex-column gap-2">
      <ix-typography format="display-sm" class="fw-semibold mb-1">
        {{ element.idShort | translateOrFallback:(element.idShort ?? '') }}
      </ix-typography>
      <div class="collection-fields d-flex flex-column gap-3 ps-3">
        @for (child of collectionChildren; track child.idShort) {
          <app-submodel-element
            [element]="child"
            [control]="getChildControl(child.idShort!)"
          />
        }
      </div>
    </div>
  }

  @case (SubmodelElementTypes.SubmodelElementList) {
    <app-submodel-element-list
      [element]="asSubmodelElementList(element)"
      [formArray]="asFormArray(control)"
    />
  }

  @default {
    <ix-input [label]="element.idShort | translateOrFallback:(element.idShort ?? '')" disabled></ix-input>
  }
}
